import { render, staticRenderFns } from "./WoModalSearch.vue?vue&type=template&id=3b9355d5&scoped=true&"
import script from "./WoModalSearch.vue?vue&type=script&lang=ts&"
export * from "./WoModalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./WoModalSearch.vue?vue&type=style&index=0&id=3b9355d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9355d5",
  null
  
)

export default component.exports